export default __webpack_public_path__ + "static/media/gradebook_placeholder.b1acca6d.svg";